/**
 * Service that allows for placing orders
 */
export class CheckoutService {
    constructor(params) {
        this.rpcService = params.rpcService;
    }
    /**
     * Send first order discount
     */
    claimFirstOrderDiscount(request) {
        return this.rpcService.rpc2("ClaimFODRequest", request);
    }
    /**
     * Place an order
     */
    checkout(request) {
        return this.rpcService.rpc("PlaceOrderRequest", request);
    }
}
